import { useQuery, useMutation, useQueryClient } from "react-query";

import { useApiService } from "../useApiService";

import { QUERY } from "../../constants/query";
import {
  CreateTenantRequest,
  TenantControllerService,
  UpdateTenantRequest,
  UpdateTenantStatusRequest,
} from "../../services";

export const useGetTenantDetails = (tenantId: string) => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.TENANT_DETAILS, tenantId];
  const query = useQuery(queryKey, () =>
    handleRequest(
      TenantControllerService.tenantControllerGetTenantDetails(tenantId)
    )
  );
  return {
    ...query,
  };
};

export const useListAllTenants = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.ALL_TENANTS];
  const query = useQuery(queryKey, () =>
    handleRequest(TenantControllerService.tenantControllerListAllTenants())
  );
  return {
    ...query,
  };
};

export const useCreateTenant = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (requestData: CreateTenantRequest) =>
      handleRequest(
        TenantControllerService.tenantControllerCreate(requestData)
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY.ALL_TENANTS);
      },
    }
  );
  return {
    ...mutation,
  };
};

export const useUpdateTenant = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();
  const mutation = useMutation(
    ({
      tenantId,
      requestData,
    }: {
      tenantId: number;
      requestData: UpdateTenantRequest;
    }) =>
      handleRequest(
        TenantControllerService.tenantControllerUpdate(tenantId, requestData)
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY.TENANT_DETAILS);
        queryClient.invalidateQueries(QUERY.ALL_TENANTS);
      },
    }
  );
  return {
    ...mutation,
  };
};

export const useUpdateTenantStatus = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();
  const mutation = useMutation(
    ({
      tenantId,
      requestData,
    }: {
      tenantId: number;
      requestData: UpdateTenantStatusRequest;
    }) =>
      handleRequest(
        TenantControllerService.tenantControllerUpdateStatus(
          tenantId,
          requestData
        )
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY.TENANT_DETAILS);
        queryClient.invalidateQueries(QUERY.ALL_TENANTS);
      },
    }
  );
  return {
    ...mutation,
  };
};

export const useDeleteTenant = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (tenantId: string) =>
      handleRequest(TenantControllerService.tenantControllerDelete(tenantId)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY.ALL_TENANTS);
      },
    }
  );
  return {
    ...mutation,
  };
};
